import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'
import RichTextEditor from 'react-rte';
import { message, Space, Row } from "antd";
import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { TextareaField, InputBaseField } from "../../../../components/InputField/InputField";
import { Label, CustomBtn } from "../../../../components/UiElements/UiElements";
import { PostDataAPI } from '../../../../../src/Services/PostDataAPI';
import { GetUserInfo } from '../../../../Services/GetUserInfo';
import DialogLoader from './../../../../components/Loader/DialogLoader';
import profilePlaceholder from './../../../../assets/img/profilePlaceholder.jpg';
import { formatDate, formateMdnNumber, formatDateTime, numberDisplay, saveActivlityLogInfo } from '../../../../../src/components/Common/Extensions';

function AddressBookSms({ dialogOpenClose, handleClose, handleSuccessClose, userData, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    let user_info = JSON.parse(GetUserInfo());
    const [userId] = useState(user_info.user.userId);
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [customerID] = useState(user_info.user.customerID);
    const [loginUser] = useState(JSON.parse(GetUserInfo()).user);
    const [errorMessage, setErrorMessage] = useState(false);
    const [errorMessageLength, setErrorMessageLength] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const [state, setState] = useState({ messageText: '', cellPhone: '' });
    const [messages, setMessages] = useState([]);
    const getContactName = () => {
        return userData?.firstName || userData?.emailAddress || userData?.phoneNumber || "selected contact";
    };
    const getContactSummary = () => {
        const details = [`notify contact ${getContactName()}`];
        if (userData?.phoneNumber)
            details.push(`phone ${userData.phoneNumber}`);
        if (userData?.emailAddress)
            details.push(`email ${userData.emailAddress}`);
        return details.join(", ");
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }


    const handleSelectChange = (name, value) => {
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const sendSMSToContact = () => {
        let success = true;

        if (!state.messageText || state.messageText.trim() == "") {
            setErrorMessage(true);
            success = false;
        } else {
            setErrorMessage(false);
        }
        if (state.messageText && state.messageText.length > 2000) {
            setErrorMessageLength(true);
            success = false;
        } else {
            setErrorMessageLength(false);
        }
        if (success == true) {
            var params = {
                customerId: parseInt(userId),
                fromId: accountNumber,
                toId: userData.contactId,
                toPhoneNumber: userData.phoneNumber,
                toName: userData.firstName,
                smsText: state.messageText,
                type: 'sms'
            };
            setIsLoading(true);

            PostDataAPI("customer/sendSMSToCustomerContact", params, true).then((result) => {

                if (result.success && result.data != null) {
                    const messageLength = state.messageText ? state.messageText.trim().length : 0;
                    saveActivlityLogInfo(
                        "Notify Contacts",
                        "SMS Sent",
                        `User sent SMS to ${getContactSummary()}, message length ${messageLength} character${messageLength == 1 ? "" : "s"}`,
                        accountNumber,
                        customerID
                    );
                    //handleSuccessClose("SMS sent successfully.");
                    loadContactMessages();
                    state.messageText = '';
                }
                else {
                    message.error(result.message, 2);
                }
                setIsLoading(false);
            });
        }

    }

    const loadContactMessages = () => {
        var params = {
            customerId: parseInt(userId),
            contactId: userData.contactId
        };
        setIsLoading(true);

        PostDataAPI("customer/loadCustomerContactMessages", params, true).then((result) => {

            if (result.success && result.data != null) {
                console.log(result.data);
                setMessages(result.data);
            }
            setIsLoading(false);
        });

    }
    useEffect(() => {
        loadContactMessages();
    }, [])

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>New SMS</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>

                        {isLoading ? <DialogLoader></DialogLoader> : ''}

                        <Scrollbars autoHeight autoHeightMax={570}>
                            <div className={classes.content}>

                                <Grid container direction="column">

                                    <div className={classes.userProfile}>

                                        <img src={userData.photoPath == null ? profilePlaceholder : '.' + userData.photoPath} alt="user" />

                                        <div className={classes.profileContent}>
                                            <span>
                                                <Typography className='userName'>{userData.firstName}</Typography>
                                                <Typography className='userPhone'>{userData.phoneNumber}</Typography>
                                            </span>
                                        </div>
                                    </div>

                                    <Grid row item lg={12} >
                                        <div className={classes.messageContainer}>

                                            {messages.map((item, i) => {
                                                return <>
                                                    <div className={classes.messageArea}>
                                                        <div className={classes.messageText}>
                                                            {item.message}
                                                        </div>
                                                        <span> {formatDateTime(item.createDate)}</span>
                                                    </div>
                                                </>
                                            })}

                                            {/*<div className={classes.messageArea}>*/}
                                            {/*    <div className={classes.messageText}>*/}
                                            {/*        Please check why my calls are disconnecting*/}
                                            {/*    </div>*/}
                                            {/*    <span> 18:10, Tue 23 may </span>*/}
                                            {/*</div>*/}

                                            {/*<div className={classes.messageArea}>*/}
                                            {/*    <div className={classes.messageText}>*/}
                                            {/*        Your Package is expiring soon*/}
                                            {/*    </div>*/}
                                            {/*    <span> 21:30, Wed 29 may </span>*/}
                                            {/*</div>*/}


                                        </div>


                                        <div className={classes.messageSendField}>
                                         
                                            <InputBaseField
                                                value={state.messageText}
                                                id="messageText"
                                                name="messageText"
                                                onChange={handleChange}
                                                type="text"
                                                placeholder="Enter message"
                                            ></InputBaseField>

                                           
                                        </div>
                                        {errorMessage && !state.messageText ? (
                                                <Typography color="secondary" className="error-message">Please enter message </Typography>
                                        ) : ("")}

                                        {errorMessageLength && state.messageText && state.messageText.length > 2000 ? (
                                            <Typography color="secondary" className="error-message">Maximum 2000 characters allowed </Typography>
                                        ) : ("")}

                                    </Grid>

                                </Grid>


                            </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Cancel</Button>
                                {isLoading ? <Button className={classes.changeBtn} >Send</Button> :
                                    <Button className={classes.changeBtn} onClick={sendSMSToContact}>Send</Button>}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default AddressBookSms;
